module.exports = __webpack_public_path__ + "static/media/logo181.1642f780.png";